import { render, staticRenderFns } from "./AddPackageInputs.vue?vue&type=template&id=6449d3b0&scoped=true"
import script from "./AddPackageInputs.vue?vue&type=script&lang=ts"
export * from "./AddPackageInputs.vue?vue&type=script&lang=ts"
import style0 from "./AddPackageInputs.vue?vue&type=style&index=0&id=6449d3b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6449d3b0",
  null
  
)

export default component.exports